<div class="estimated-financials-container">
  <div class="estimated-financials-panel">
    <div class="estimated-financials-header">
      <div>Fiscal Year (FY)</div>
      <div>
        <label>Estimated TNC Costs (USD)<app-help-selector [selector]="1148"></app-help-selector></label>
      </div>
      <div>
        <label>Estimated Non-TNC Costs (USD)<app-help-selector [selector]="1149"></app-help-selector></label>
      </div>
    </div>

    <div class="estimated-financials-body">
      @for (yearForm of fiscalYearArray.controls; track yearForm; let i = $index) {
        <div class="estimated-financials-table">
          <div class="estimated-financials-row">
            <div>
              FY{{getFiscalYear(yearForm)}}
            </div>
            <div>
              <input type="number" [formControl]="yearForm.controls.estimatedTncCosts.controls.financeValue">
            </div>
            <div>
              <input type="number"
                [formControl]="yearForm.controls.estimatedNonTncCosts.controls.financeValue">
            </div>
          </div>
        </div>
      }
    </div>
    <div class="estimated-financials-footer">
      <div>Total</div>
      <div>
        {{getTotalEstimatedTncCosts() | currency: "USD": "symbol": "1.0-0"}}
      </div>
      <div>
        {{getTotalEstimatedNonTncCosts() | currency: "USD": "symbol": "1.0-0"}}
      </div>
    </div>
  </div>

</div>
